import { DOCUMENT } from "@angular/common";
import { inject } from "@angular/core";

import { FileDownloadBundle } from "@intocare/datatypes/lib/bundle";

import { MatomoService } from "./matomo.service";

type DownLoadIndentifier = {
	name: string;
	group: string;
};

export function injectDownloadFile() {
	const document = inject(DOCUMENT);
	const matomoService = inject(MatomoService);

	return (bundle: FileDownloadBundle, identifier?: DownLoadIndentifier): void => {
		const localWindow = document.defaultView;
		if (!localWindow) {
			// Window is not available, cannot perform download so nothing to report either
			return;
		}
		localWindow.open(bundle.url, "_blank");
		// name is not the actual link, but should be used as the name of the downloaded file, so we can track it in Matomo with the correct name
		// protocol is needed for Matomo to track the download
		matomoService.trackDownloadByName(identifier ? `https://${identifier.group}/${identifier.name}` : bundle.url);
	};
}
